var L1Types = /* @__PURE__ */ ((L1Types2) => {
  L1Types2[L1Types2["Evm"] = 0] = "Evm";
  L1Types2[L1Types2["Btc"] = 1] = "Btc";
  L1Types2[L1Types2["Svm"] = 2] = "Svm";
  return L1Types2;
})(L1Types || {});
export {
  L1Types
};
//# sourceMappingURL=common.js.map